import React from "react";
import PropTypes from "prop-types";
import getConfig from "next/config";
import Heading from "@components/Heading";
import RegionsBox from "@components/Stores/RegionsBox";

const {
  publicRuntimeConfig: {
    content: { websiteTitle },
    settings: { websiteStatics },
  },
} = getConfig();

const StoresLayout = ({ children, title, regions }) => {
  return (
    <article className="lg:pt-10">
      <Heading
        title={title}
        as="h1"
        display="h1"
        classesProp="text-left mb-2 mt-4 lg:mt-0"
      />

      <div className="">
        <div className="pt-3 pr-8 text-justify text-sm">
          <p className="mt-0 leading-22 lg:leading-20 -tracking-0.39">
            {`Prin reteaua nationala de magazine, ${websiteTitle} iti ofera o gama variata de produse, la cele mai avantajoase preturi, sustinute de solutii optime de finantare, adaptate fiecarui tip de buget.`}
          </p>
        </div>

        {children}
      </div>

      <Heading
        title={`Vezi magazinele ${websiteTitle} din regiune`}
        as="h1"
        display="h1"
      />

      <div className="mt-4">
        <RegionsBox regions={regions} />
      </div>
    </article>
  );
};

StoresLayout.prototype = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  regions: PropTypes.object.isRequired,
};

export default StoresLayout;
